import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Whether to show distance estimates.
 */
export const schema = z.boolean();

export type DistanceEstimates = z.infer<typeof schema>;

export const definition = define({
  key: 'distance_estimates',
  schema,
  label: 'Activate Distance Estimates',
  description:
    'Activate/Deactivate the distance estimates feature for clients at this level. This will allow the client to see distance estimates for their moves before they create them.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.MOVE_PLANNING.key,
  writableAtLevels: [
    LEVELS.HOPDRIVE,
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
